import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Link } from 'react-router-dom';
import { Actions } from '../../flux';
import { images, texts, relacionamentos } from '../../settings';
import { DelayLink, SliderText } from '../../components';

import './NossoAno.scss';

class NossoAno extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Nosso Ano - {texts.title}</title>
        </Helmet>

        <div className="nosso-ano-home page-gradient page-gradient--blue bg-gray" ref="nosso-ano-home">
          <section className="nosso-ano-home-area page-gradient__header">
            <div className="container">
              <div className="row">
                <div className="col-5">
                  <Fade bottom>
                    <div className="page-header">
                      <h1 className="page-header__title">O que fizemos?</h1>
                      <p className="page-header__description gri_text">
                        Para defender os interesses dos associados e trabalhar pelo desenvolvimento do mercado, nossas
                        atividades são baseadas no{' '}
                        <DelayLink
                          to="/plano-de-acao-2019"
                          className="text_link text_link--white text_link--white-to-blue"
                        >
                          Plano de ação
                        </DelayLink>
                        .
                        <br />
                        <br />
                        Como o mercado é dinâmico, também ficamos atentos às demandas que surgem no decorrer do ano.
                        Além disso, cuidamos para que a equipe interna esteja sempre preparada para atender aos desafios
                        impostos por esse trabalho.
                      </p>
                    </div>
                  </Fade>
                </div>

                <div className="col-7 col-image">
                  <img src={images.nosso_ano.pessoa_topo} className="pessoa" />
                  <img src={images.nosso_ano.ponteiro} className="ponteiro" />
                </div>
              </div>
            </div>
          </section>

          <section className="nosso-ano-body">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="governanca-body__content">
                    <Fade bottom>
                      <div className="shadowed_header">
                        <h2 className="center-title high green">Confira as principais iniciativas do ano</h2>
                      </div>
                    </Fade>
                  </div>
                </div>
                <div className="col-12">
                  <div className="col-6">
                    <Fade bottom>
                      <DelayLink to="/estrategias/para-o-mercado" className="card card--yellow">
                        <div className="card__content card__content--full">
                          <div className="card__content__header card__content__header--no-border">
                            <h2 className="title title--gray title--large">Para o mercado</h2>
                          </div>
                          <div className="card__content__body">
                            <div className="button button--aylen button--yellow button--border-medium button--size-m button--round-l button--text-thick">
                              Veja como foi
                            </div>
                          </div>
                        </div>
                      </DelayLink>
                    </Fade>
                  </div>

                  <div className="col-6">
                    <Fade bottom>
                      <DelayLink to="/estrategias/dentro-de-casa" className="card card--light-blue">
                        <div className="card__content card__content--full">
                          <div className="card__content__header card__content__header--no-border">
                            <h2 className="title title--gray title--large">Dentro de casa</h2>
                          </div>
                          <div className="card__content__body">
                            <div className="button button--aylen button--light-blue button--border-medium button--size-m button--round-l button--text-thick">
                              Veja como foi
                            </div>
                          </div>
                        </div>
                      </DelayLink>
                    </Fade>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="nosso-ano-footer-area governanca-footer">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="box-pill box-pill--green box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-8 col--text">
                            <h4>Veja os eventos de 2019</h4>
                            <DelayLink
                              to="/eventos"
                              className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Saiba mais
                            </DelayLink>
                          </div>
                          <div className="col col-4 col--image">
                            <img
                              src={images.nosso_ano.pessoa_destaque}
                              className="pessoa_destaque pessoa_destaque--1"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { NossoAno };
